import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel", "chevron"]

  toggle(event) {
    const button = event.currentTarget
    const index = this.buttonTargets.indexOf(button)
    const willOpen = this.panelTargets[index].classList.contains("hidden")

    this.panelTargets.forEach((panel, i) => {
      const open = i === index && willOpen
      panel.classList.toggle("hidden", !open)
      this.buttonTargets[i].setAttribute("aria-expanded", open.toString())
      if (this.chevronTargets[i]) {
        this.chevronTargets[i].style.transform = open ? "rotate(180deg)" : ""
      }
    })
  }
}
